import { UseMutationOptions } from '@tanstack/react-query';
import { AxiosMethods } from '../../../../enums';
import { axiosHelper } from '../../../axios-instance';
import { GetPricingRequest, GetPricingResponse } from './types';

export * from './types';

export enum PricingQueryKey {
  PRICING = 'pricing'
}

/**
 * Get product pricing
 * This is a POST request but returns pricing data (read operation)
 * Can be used with useMutation for flexibility
 */
export const getProductsPricingMutation = (): UseMutationOptions<
  GetPricingResponse,
  Error,
  GetPricingRequest
> => ({
  mutationKey: [PricingQueryKey.PRICING],
  mutationFn: (body: GetPricingRequest) =>
    axiosHelper({
      baseURL: process.env.REVOPS_API,
      endpoint: '/pricing/get',
      method: AxiosMethods.POST,
      body
    }) as Promise<GetPricingResponse>
});

/**
 * Direct function to fetch product pricing (for imperative use)
 * Use this when you need to fetch pricing outside of React Query hooks
 */
export const fetchProductsPricing = async (
  body: GetPricingRequest
): Promise<GetPricingResponse> =>
  axiosHelper({
    baseURL: process.env.REVOPS_API,
    endpoint: '/pricing/get',
    method: AxiosMethods.POST,
    body
  }) as Promise<GetPricingResponse>;
